import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var Parameter = /*#__PURE__*/function () {
  function Parameter(parameter) {
    if (parameter) {
      this._name = parameter.name;
      this._value = parameter.value;
    }
  }

  var _proto = Parameter.prototype;

  _proto.getParameterObjectification = function getParameterObjectification() {
    return {
      name: this._name,
      value: this._value
    };
  };

  _createClass(Parameter, [{
    key: 'name',
    get: function get() {
      return this._name;
    }
  }, {
    key: 'value',
    get: function get() {
      return this._value;
    }
  }]);

  return Parameter;
}();

export { Parameter as default };